<template>
	<div class="body">
		<div class="search-box">
			<div>
				<span class="title">年级：</span>
				<el-date-picker
				  v-model="date"
				  type="year"
				  placeholder="选择年级"
				  clearable
				  format="yyyy"
				  value-format="yyyy"
				  @change="pageIndex=1,isDate()"
				  class="site_year search-input"
				  >
				</el-date-picker>
			</div>
			<div style='margin-left: 16px'>
				<span class="title">专业：</span>
				<el-select class="search-input" filterable clearable v-model="career" placeholder="专业" @change="pageIndex=1,reloadData()" @clear="isCareer">
					<el-option class="form-item form-input"
						v-for="item in major"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					>
					</el-option>
				</el-select>
			</div>
			<div style='margin-left: 16px'>
				<span class="title">学期：</span>
				<el-select class="search-input" clearable v-model="session" placeholder="学期" @change="pageIndex=1,reloadData()" @clear="isSession">
					<el-option class="form-item form-input"
						v-for="item in term"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					>
					</el-option>
				</el-select>
			</div>

			<div class='margin-left-30'>
				<el-button class="primary-btn" @click="reset()">重置</el-button>
				<el-button type="primary"  style="margin-left: 16px">查询</el-button>
			</div>
			</div>

			<div class="container">
				    <el-button
				    type="primary"
				    icon="el-icon-circle-plus-outline"
				    class="handle-del mr10"
					@click="onekey()"
				    >一键开课
				    </el-button>
					<!-- 表单 -->
					<div class="table-cls">
					    <el-table
							ref = 'multipleTable'
					        :data="tableData"
					        border
					        class="table"
							:cell-style="{color:'#666666',height:'55px'}"
							:header-cell-style="{background:'#eef1f6',color:'#333333',height:'49px',fontWeight:500}"
					        v-loading="loading"
							>
							<el-table-column
							  type="selection"
							  align='center'
							  width="55"
							  :selectable="isDisabled"
							 >
							</el-table-column>
							<el-table-column prop="grade" align='center' label="年级" width="100px"></el-table-column>
							<el-table-column prop="level" align='center' label="层次"></el-table-column>
                            <el-table-column prop="name" align='center' label="专业"></el-table-column>
					        <el-table-column prop="semester" align='center' label="学期">
								<template slot-scope="scope" >
									<div>
								       {{semester[scope.row.semester]}}
								    </div>
								</template>
							</el-table-column>
							<el-table-column prop="open_state" align='center' label="开课情况">
								<template slot-scope="scope" >
									<div :class="scope.row.open_state==1?'color-blue':'color-red'">
								       {{open_state[scope.row.open_state]}}
								    </div>
								</template>
							</el-table-column>
							<el-table-column prop="org" align="center" label="所属院校" v-if="this.org === '1'">
								<template slot-scope="scope">
									{{org_list_hash[scope.row.org]}}
								</template>
							</el-table-column>
					    </el-table>
					</div>

					<!-- 分页 -->
					<div class="pagination">
					    <el-pagination
							background
					        layout="total, prev, pager, next"
					        :current-page=pageIndex
					        :page-size=10
					        :total=pageTotal
					        @current-change="handlePageChange"
					    ></el-pagination>
					</div>

		</div>
	</div>
</template>

<script>
	import { isBlank,htmlDecode,htmlEncode} from '../../utils/util';
	export default {
		data() {
		    return {
				loading:false,
				// 分页
				pageIndex: 1,
				pageSize: 10,
				pageTotal: 0,
				option1: 1,
				option2: 2,
				tableData:[],
				// 全选
				multipleSelection: [],
				// 表单
				semester:[],
				open_state:[],
				//头部 日期
				date:'',
				// 学期
				term:[],
				session:[],
				// 年级
				// 专业
				major:[],
				career:[],
				// 一键开课
				tution_list:[],
				org:-1,
				org_list_hash:[]
			}
		},
		created() {
		    this.getData();
			// 转换值
			this.getTransitionValue()
			this.getMajor()
			this.getTblInfo();
			//获取当前账号的所属院校
			this.org = localStorage.getItem("org");
		},
		mounted() {

		},
		methods: {
			//重置
			reset(){
				this.option1=1;
				this.pageIndex=1;
				this.date='';
				this.career='';
				this.session='';
				this.getData()
			},
			//获取页面
			getData() {
				if(isBlank(this.pageIndex)){
					this.pageIndex=1
				}
				this.$get(this.BASEURL + '/tution/major/management?page=' + this.pageIndex + '&option=' + this.option1 ).then((res) => {
					if (res.code === 200) {
						this.tableData = res.data;
						this.pageTotal = res.total;
					} else {
						console.log(res.error);
					}
				});
			},
			getTblInfo(){
				this.$post(this.BASEURL+'/assets/table/info',{
					tbl_list:[['org','org_name','academy_base_t']],
					state:0
				}).then((res)=>{
					if(res.code === 200){
						this.org_list_hash = res.data[0][1]
					}else{
						console.log(res.error);
					}
				})
			},
			//搜索
			reloadData(){
				if(isBlank(this.pageIndex)){
					this.pageIndex=1
				}
				if(this.date==null){
					this.date=''
				}
				if(isBlank(this.date) && isBlank(this.career) && isBlank(this.session)){
					return
				}
				else{

					this.$get(this.BASEURL + '/tution/major/management?page=' + this.pageIndex + '&option=' + this.option2 + '&grade=' +this.date + '&major=' + this.career + '&semester=' + this.session ).then((res) => {
							if (res.code === 200) {
								this.tableData = res.data;
								this.pageTotal = res.total;
							} else {
								console.log(res.error);
							}
					});

				}

			},
				// 分页导航
				handlePageChange(val) {
				    this.pageIndex = val
					let page=val
					// if(this.date==null){
					// 	this.date=''
					// 	console.log('33',this.date)
					// }
					if(isBlank(this.date) && isBlank(this.career) && isBlank(this.session)){
						this.getData(page);
						return
					}else{
						this.reloadData(page)
					}
				},
				// 下拉选项清空事件
				isCareer(){
					this.career=''
					this.handlePageChange()
				},
				isSession(){
					this.session=''
					this.handlePageChange()
				},
				isDate(){
					if(isBlank(this.date)){
						this.date=''
						console.log('33',this.date)
						this.handlePageChange()
					}
					this.reloadData()
				},
				//全选
				toggleSelection(rows) {
					if (rows) {
					  rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					  });
					} else {
					  this.$refs.multipleTable.clearSelection();
					}
				},
				// 禁止使用
				isDisabled(row){
				  if(row.open_state === 1){
					return 0;
				  }
				  return 1;
				},
				// 转换值
				getTransitionValue(){
					let data = [
					    'major_tution_state','major_semester'
					]
						this.$post(
							this.BASEURL + '/assets/transition/GET', {
								'key_list': data
							}).then((res) => {
							if (res.code === 200) {
								console.log('post',res.data)
								this.term=res.data.major_semester[0];
								this.semester=res.data.major_semester[1];
								this.open_state=res.data.major_tution_state[1];
							} else {
								console.log(res.error);
							}
						});
				},
				// 一键开课
				onekey() {

					let list=this.$refs.multipleTable.selection;
					this.tution_list=list.map(function(item,i,list){
						return{
							id: list[i].id,
							open_state: list[i].open_state
						}
					})
					if(isBlank(this.tution_list)){
						this.$message.error(`请先选择开课专业！`);
						return
					}else{
						this.$post(
							this.BASEURL + '/tution/major/management', {
								'tution_list': this.tution_list ,
							}).then((res) => {
							if (res.code === 200) {
								this.$message.success(`开课成功！`);
								if(isBlank(this.date) && isBlank(this.career) && isBlank(this.session)){
									console.log('11')
									this.getData();
									return
								}
								this.reloadData();
							} else {
								this.$message.error(res.error);
							}
						});
					}

				},
				// 获取专业
				getMajor(){
					// this.$get(this.BASEURL + '/assets/major/info/GET').then((res) => {
					// 	if (res.code === 200) {
					// 		this.major=res.data;
					// 	} else {
					// 		console.log(res.error);
					// 	}
					// });
					let data =
					this.$post(this.BASEURL+'/assets/table/info',{
						tbl_list:[['id','grade,name','major_base_t']],
						state:1
					}).then((res)=>{
						if(res.code === 200){
							this.major = res.data[0][0]
						}else{
							console.log(res.error);
						}
					})
				},
		}

	}
</script>

<style lang="scss" scoped>
	.body{
		button{
			padding: 8px 15px;
			font-size: 14px;
		}
	}
	.search-box{
		background-color: #ffffff;
		display: flex;
		align-items: center;
		/*justify-content: space-between;*/
		padding: 28px 30px;
		margin-top: $distance;
		margin-bottom: $distance;
		border-radius: $radius;
		.search-input{
			width: 240px;
		}
		.title{
			font-size:$title-size;
			line-height:15px;
			color: #343434;
		}
	}
	.primary-btn{
	    border-color: #409EFF;
	    color: #409EFF;
	}
	.handle-box {
	    margin-bottom: 20px;
	    text-align: right;
	    margin-right: 20px;
	    display: flex;
	    justify-content: space-between;
	    .search{
	        display: flex;
	    }
	}

/* 表单 */
	.table-cls{
	    text-align: center;
	    margin-top: 28px;
		width: 100%;
	}
	.table {
	    width: 100%;
	    font-size: 14px;
	}
</style>
